import WindowVisibilityHelper from './AudioAlerts/WindowVisibilityHelper';
import { frontendURL, conversationUrl } from './URLHelper';

const AUTO_CLOSE_MS = 6000;
const FALLBACK_ICON = '/favicon-32x32.png';

// Eltafouk: a foreground native desktop notification for an @mention, shown
// only when the Chatwoot tab is open but NOT focused — so an agent working in
// another tab/app still gets alerted the moment they're mentioned. It
// complements the in-app sound + sidebar badge (which already fire) and uses
// the rich `notification.created` payload (localized title + "who: note"
// preview). No-ops silently when notifications aren't permitted, the tab is
// already focused, or the payload is incomplete.
export const showMentionDesktopNotification = notification => {
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (window.Notification.permission !== 'granted') return;
  // Tab is focused → the agent is already looking; sound/badge are enough.
  if (WindowVisibilityHelper.isWindowVisible()) return;

  const conversationId = notification?.primary_actor?.id;
  const title = notification?.push_message_title;
  if (!conversationId || !title) return;

  const sender = notification?.secondary_actor?.sender || {};
  // The backend's title for a mention is already "<who>: <note preview>"; use
  // the customer/contact name as the body so the agent also sees which
  // conversation it's in (avoids showing the same text twice).
  const contactName = notification?.primary_actor?.meta?.sender?.name || '';
  const url = frontendURL(
    conversationUrl({
      accountId: notification.account_id,
      id: conversationId,
      conversationType: 'mention',
    })
  );

  try {
    const desktopNotification = new window.Notification(title, {
      body: contactName,
      icon: sender.avatar_url || sender.thumbnail || FALLBACK_ICON,
      // One notification per conversation — a re-mention replaces it instead of
      // stacking duplicates.
      tag: `mention-${conversationId}`,
      data: { url },
    });

    desktopNotification.onclick = () => {
      window.focus();
      window.location.href = url;
      desktopNotification.close();
    };

    setTimeout(() => desktopNotification.close(), AUTO_CLOSE_MS);
  } catch (error) {
    // Some browsers throw when constructing notifications in an unsupported
    // context — fail silently; the in-app sound + badge already alerted.
  }
};

export default showMentionDesktopNotification;
